/* eslint-disable */
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    wxConfigFlag: false,
    transitionName: "slide-left",
    // 首页数据
    hotTesting: [],
    ProductLarge: [],
    /* 已选项数量 */
    shoppingCartNumber: 0,
    tootsFlag: false,
    tootsTxt: '',
    tootsSuccessFlag: false,
    tootsSuccessTxt: "",
    // 节流阀
    closureFlag: true,
    /* 加载中弹窗 */
    loadingFlag: false,
    loadingTxt: "加载中",
    /* 分享引导页 */
    shareFlag: false,
    title: "",
    PCFlag: false,
    // 安卓是否显示PDF报告
    PDFFlag: false,
    discount: 0,
  },
  mutations: {},
  actions: {}
})